import React from "react";
import { cn } from "utils";
import { Icon } from "@ospweb/sdk-ui";
import type { SnackbarNotificationProps } from "./types";

export const SnackbarNotification: React.FC<SnackbarNotificationProps> = ({
  message,
  icon = "info-circle",
  className,
}) => {
  return (
    <div
      className={cn(
        "bg-background_solid_quaternary relative md:w-56 h-8 rounded-2 mx-2",
        "flex gap-4 items-center px-1.5 py-1.5",
        "border border-border_white_transparent10",
        "shadow-[0px_4px_40px_0px_rgba(0,0,0,0.2)]",
        className,
      )}
    >
      <div className="flex gap-1 items-center shrink-0">
        <div className="flex items-start shrink-0 w-4 h-4 text-content_accent3_primary">
          <Icon name={icon} size={16} />
        </div>
        <div className="body_medium_m text-content_primary whitespace-nowrap">
          {message}
        </div>
      </div>
    </div>
  );
};
